// Grilla de carpetas (categorías fijas de SST) dentro de una empresa o de
// Documentos Originales, con el conteo de documentos de cada una.
import { FolderOpen, ArrowRight, AlertCircle, FileText, LayoutGrid } from "lucide-react";
import { useDocs } from "../context/DocsContext";
import { CATEGORIES, folderColor } from "../constants";
import { SkeletonGrid } from "./Skeletons";

const ALL = "Todos";
const FOLDERS = [ALL, ...CATEGORIES];

export default function FolderGrid({ search, onEnter }) {
  const { docs, loading, error } = useDocs();

  const countFor = (f) => f === ALL ? docs.length : docs.filter(d => d.category === f).length;

  const filtered = FOLDERS.filter(f => f.toLowerCase().includes((search || "").toLowerCase()));

  if (loading) return <SkeletonGrid variant="company" count={FOLDERS.length} />;

  if (error) return (
    <div className="empty-state">
      <AlertCircle size={40} style={{ color: "#E53E3E", opacity: 0.7 }} />
      <p style={{ color: "#E53E3E" }}>{error}</p>
    </div>
  );

  if (filtered.length === 0) return (
    <div className="empty-state">
      <FolderOpen size={48} opacity={0.3} />
      <p>Sin resultados para tu búsqueda.</p>
    </div>
  );

  return (
    <div className="company-grid">
      {filtered.map(f => {
        const isAll = f === ALL;
        const color = isAll ? "#00A896" : folderColor(f);
        const count = countFor(f);
        return (
          <div key={f} className="company-card" onClick={() => onEnter(f)}>
            <div className="company-card-top">
              <div className="company-avatar-lg" style={{ background: color }}>
                {isAll ? <LayoutGrid size={24} /> : <FolderOpen size={24} />}
              </div>
            </div>

            <div className="company-card-body">
              <h3 className="company-name" title={f}>{f}</h3>
            </div>

            <div className="company-card-footer">
              <span style={{ display: "flex", alignItems: "center", gap: 5, color: "var(--text-muted)", fontSize: "0.72rem" }}>
                <FileText size={13} /> {count} documento{count !== 1 ? "s" : ""}
              </span>
            </div>

            <div className="company-card-enter">
              Ver documentos <ArrowRight size={14} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
